import { getLocale } from './i18n';
import { UTCTimestamp } from 'lightweight-charts';
import { DateTime, DateTimeFormatOptions } from 'luxon';

export const isValidNumber = (value: string | number): boolean => {
  const pattern = /^[+-]?[0-9]*\.?[0-9]+([eE][+-]?[0-9]+)?$/;
  return pattern.test(value.toString());
};

export const getEuroFormat = (value, currencyDisplay: 'code' | 'symbol' = 'code') => {
  if (isNaN(Number(value))) {
    return '';
  }

  return new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: currencyDisplay
  })
    .format(Number(value))
    .replace(/^(-)?([A-Z]{3}|€)\s*(.+)$/, '$1$3 $2');
};

export const getPercentFormat = (value): string => {
  if (isNaN(Number(value))) {
    return '';
  }

  return new Intl.NumberFormat(getLocale(), {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(value));
};

export const euroFormatterNoSymbol = (value) => {
  if (isNaN(Number(value))) {
    return '';
  }

  return new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code'
  })
    .format(Number(value))
    .replace('EUR', '')
    .trim();
};

export const removeTags = (value) => {
  if (!value) {
    return '';
  } else {
    return value.replace(/<\/?[^>]+(>|$)/g, '');
  }
};

export const timeFormatter = (time: UTCTimestamp) => {
  const localDate = new Date(time * 1000);
  const minute = localDate.getMinutes() < 10 ? `0${localDate.getMinutes()}` : localDate.getMinutes().toString();
  const hour = localDate.getHours() < 10 ? `0${localDate.getHours()}` : localDate.getHours().toString();

  return `${localDate.toLocaleDateString(getLocale(), { month: 'short', day: 'numeric' })} ${hour}:${minute}`;
};

export const getShortDateTimeString = (date: Date | string | undefined | null, includeTime = true) => {
  if (!date) {
    return undefined;
  }

  let formatOptions: DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };

  if (includeTime) {
    formatOptions = {
      ...formatOptions,
      hour: '2-digit',
      hourCycle: 'h23',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'shortOffset'
    };
  }

  const dateTime = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date);

  return dateTime.setLocale(getLocale()).toLocaleString(formatOptions);
};
